<template>
  <div class="publicItems">
    <div class="selectionArea">
      <div class="item">
        <span class="item_title">投放组</span>
        <el-autocomplete
          v-model="parameterNames.release_group_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投放组'"
          @select="handleSelect"
          @clear="release_group_id = null"
        />
      </div>
      <div class="item">
        <span class="item_title">投手</span>
        <el-autocomplete
          v-model="parameterNames.pitcher_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '投手'"
          @select="handleSelect"
          @clear="pitcher_id = null"
        />
      </div>
      <div class="item">
        <span class="item_title">运营组</span>
        <el-autocomplete
          v-model="parameterNames.operation_group_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '运营组'"
          @clear="operation_group_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">运营者</span>
        <el-autocomplete
          v-model="parameterNames.operation_id_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '运营者'"
          @clear="operation_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">平台</span>
        <el-autocomplete
          v-model="parameterNames.platform_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请选择平台"
          :clearable="true"
          @focus="current = '平台'"
          @clear="platform_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">书名</span>
        <el-autocomplete
          v-model="parameterNames.book_name"
          :fetch-suggestions="querySearchAsync"
          placeholder="请输入内容"
          :clearable="true"
          @focus="current = '书名'"
          @clear="parameter.book_id = null"
          @select="handleSelect"
        />
      </div>
      <div class="item">
        <span class="item_title">日期</span>
        <el-date-picker
          v-model="date"
          type="daterange"
          range-separator="至"
          value-format="yyyy-MM-dd"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        />
      </div>
      <el-button style="height:37px" type="primary" icon="el-icon-search" @click="search()">搜索</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-refresh-left" @click="reset">重置</el-button>
      <el-button style="height:37px" type="primary" icon="el-icon-bottom" @click="reportExport">导出总计报表</el-button>
    </div>
    <div class="content1">
      <div>合计</div>
      <div>
        <div>消耗：</div>
        <div>{{ tableData.total_data && tableData.total_data.stat_cost ? tableData.total_data.stat_cost : 0 }}</div>
        <!--        <div-->
        <!--          v-if="total_data.rio !== 0"-->
        <!--          :class="{ color1: total_data.is_rio, color2: !total_data.is_rio }"-->
        <!--        >-->
        <!--          <div>{{ total_data.is_rio ? '↑' : '↓' }}</div>-->
        <!--          <div>-->
        <!--            {{ total_data.is_rio ? total_data.rio : total_data.rio * -1 }}%-->
        <!--          </div>-->
        <!--        </div>-->
      </div>
      <div>
        <div>小游戏/小程序当日广告变现ROI：</div>
        <div>{{ tableData.total_data && tableData.total_data.attribution_micro_game_0d_roi ? tableData.total_data.attribution_micro_game_0d_roi : 0 }}</div>
      </div>
      <div>
        <div>小游戏/小程序三日广告变现ROI：</div>
        <div>{{ tableData.total_data && tableData.total_data.attribution_micro_game_3d_roi ? tableData.total_data.attribution_micro_game_3d_roi : 0 }}</div>
      </div>
      <div>
        <div>小游戏/小程序七日广告变现ROI：</div>
        <div>{{ tableData.total_data && tableData.total_data.attribution_micro_game_7d_roi ? tableData.total_data.attribution_micro_game_7d_roi : 0 }}</div>
      </div>
      <div>
        <div>平均千次展示费用：</div>
        <div>{{ tableData.total_data && tableData.total_data.cpm_platform ? tableData.total_data.cpm_platform : 0 }}</div>
      </div>
      <div>
        <div>点击率：</div>
        <div>{{ tableData.total_data && tableData.total_data.ctr ? tableData.total_data.ctr : 0 }}</div>
      </div>
      <div>
        <div>激活数：</div>
        <div>{{ tableData.total_data && tableData.total_data.active ? tableData.total_data.active : 0 }}</div>
      </div>
      <div>
        <div>激活成本：</div>
        <div>{{ tableData.total_data && tableData.total_data.active_cost ? tableData.total_data.active_cost : 0 }}</div>
      </div>
      <div>
        <div>转化率：</div>
        <div>{{ tableData.total_data && tableData.total_data.conversion_rate ? tableData.total_data.conversion_rate : 0 }}</div>
      </div>
      <div>
        <div>平均转化成本：</div>
        <div>{{ tableData.total_data && tableData.total_data.conversion_cost ? tableData.total_data.conversion_cost : 0 }}</div>
      </div>
    </div>
    <div>
      <el-table
        ref="tableRef"
        v-loading="loading"
        :data="tableData.list"
        max-height="650"
        style="width: 100%"
        border
        @sort-change="sortChange"
      >
        <el-table-column prop="operation_group_name" label="运营组" width="150" />
        <el-table-column prop="operation_name" label="运营者" width="150" />
        <el-table-column prop="book_name" label="书籍" width="150" />
        <el-table-column prop="stat_cost" label="消耗" width="150" />
        <el-table-column prop="attribution_micro_game_0d_roi" label="小程序/小游戏首日广告变现ROI" width="150" />
        <el-table-column prop="attribution_micro_game_3d_roi" label="小程序/小游戏三日广告变现ROI" width="150" />
        <el-table-column prop="attribution_micro_game_7d_roi" label="小程序/小游戏七日广告变现ROI" width="150" />
        <el-table-column prop="cpm_platform" label="平均千次展示费用" width="150" />
        <el-table-column prop="ctr" label="点击率" width="150" />
        <el-table-column prop="active" label="激活数" width="150" />
        <el-table-column prop="active_cost" label="激活成本" width="150" />
        <el-table-column prop="conversion_rate" label="转化率" width="150" />
        <el-table-column prop="conversion_cost" label="平均转化成本" width="150" />
      </el-table>
    </div>

    <pagination-right
      :total="tableData.count"
      @size-change="fetchPageSize"
      @current-change="fetchCurrentPage"
    />

  </div>
</template>

<script>
import { getTotalReportList, getReleaseGroupList, getListOfPitchersInTheLaunchGroup, getOperationGroupList, getOperatorList, getTitleList, getBookOwnershipList, modifyConsumption, exportTotalReport } from '@/api/oceanNovelReport.js'
import PaginationRight from '@/components/PaginationRight/index.vue'
import { getSelectList } from '@/api/report/SelectData.js'
export default {
  components: {
    PaginationRight
    /* Details */
  },
  data() {
    return {
      tableData: {},
      loading: false,
      parameter: {
        page: 1,
        page_size: 10,
        release_group_id: null,
        pitcher_id: null,
        operation_group_id: null,
        operation_id: null,
        book_id: null,
        platform_id: null
      },
      parameterNames: {
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        operation_group_id_name: null, // 运营组
        operation_id_name: null, // 运营者
        book_name: null, // 书名
        platform_name: null
      },
      current: null,
      date: [],
      activeItem: null,
      activeText: null,
      drawerItem: {},
      order_by: {} // 表格数据排序
    }
  },
  created() {
    window.aa = this
    this.getDataList()
  },
  methods: {
    // 获取数据列表
    async getDataList(obj = {}) {
      if (JSON.stringify(this.order_by) === '{}') {
        this.order_by = {
          order: 'desc',
          field: 'channel_date'
        }
      }
      this.loading = true
      const ob1 = Object.keys(obj).length ? obj : this.parameter
      const data = await getTotalReportList({ ...ob1,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null,
        order_by:
          this.order_by && this.order_by.field && this.order_by.order
            ? this.order_by
            : null })
      this.tableData = data.data
      this.loading = false
    },

    // 修改
    modify(row) {
      this.dialogVisible = true
      this.drawerItem = row
    },

    // 分页
    fetchPageSize(s) {
      this.parameter.page_size = s
      this.search(true)
    },

    // 分页
    fetchCurrentPage(s) {
      this.parameter.page = s
      this.search(true)
    },

    // 搜索
    async querySearchAsync(queryString, cb) {
      let currentFunc = null
      const obj = {
        '投放组': 'release_group_name',
        '投手': 'user_name',
        '运营组': 'operation_group_name',
        '运营者': 'user_name',
        '书名': 'book_name'
      }

      switch (this.current) {
        case '投放组': currentFunc = getReleaseGroupList
          break
        case '投手': currentFunc = getListOfPitchersInTheLaunchGroup
          break
        case '运营组': currentFunc = getOperationGroupList
          break
        case '运营者': currentFunc = getOperatorList
          break
        case '书名': currentFunc = getTitleList
          break
        case '书籍归属': currentFunc = getBookOwnershipList
          break
        case '平台':
          currentFunc = getSelectList
          break
      }
      if (!currentFunc) {
        return
      }
      if (this.current === '投手' && !this.parameter.release_group_id || this.current === '运营者' && !this.parameter.operation_group_id) {
        const obj1 = {
          '投手': '请先选投放组，才能选投手',
          '运营者': '请先选运营组，才能选运营者'
        }
        this.$message({
          message: obj1[this.current],
          type: 'warning'
        })
        cb()
        return
      }
      const data = await currentFunc({
        name: queryString || null,
        group_id: this.current === '投手' ? this.parameter.release_group_id.address : this.current === '运营者' ? this.parameter.operation_group_id.address : null,
        book_belong_id: this.parameter.book_id ? this.parameter.book_id.address : null,
        type: this.current === '投放组' ? 2 : null
      })
      console.log(data)
      if (this.current === '书籍类型') {
        cb(data.data.map((item) => {
          return {
            value: item,
            address: item
          }
        }))
        return
      }
      if (this.current === '平台') {
        cb(
          data.data.platform.map(item => {
            return {
              value: item.name,
              address: item.id
            }
          })
        )
        return
      }
      if (this.current === '投手') {
        cb(
          data.data.group_user.map(item => {
            return {
              value: item.nickname,
              address: item.bind_id
            }
          })
        )
        return
      }
      cb(data.data.list.map((item) => {
        return {
          value: item[obj[this.current]],
          address: item.id
        }
      }))
    },

    // 选中哪一项
    handleSelect(item) {
      switch (this.current) {
        case '投放组' : this.parameter.release_group_id = item
          break
        case '投手' : this.parameter.pitcher_id = item
          break
        case '运营组' : this.parameter.operation_group_id = item
          break
        case '运营者' : this.parameter.operation_id = item
          break
        case '书名' : this.parameter.book_id = item
          break
        case '平台':
          this.parameter.platform_id = item
          break
      }
    },

    // 搜索
    search(value) {
      value || (this.parameter.page = 1)
      const obj = {
        release_group_id: 'release_group_id_name',
        pitcher_id: 'pitcher_id_name',
        operation_group_id: 'operation_group_id_name',
        operation_id: 'operation_id_name',
        book_id: 'book_name',
        platform_id: 'platform_name'
      }
      const keys = Object.keys(this.parameter)
      console.log(this.parameter.book_id)
      const obj1 = {}
      keys.map((key, index) => {
        console.log(key)
        if (this.parameter[key] && (this.parameter[key].value === this.parameterNames[obj[key]]) && key !== 'page' && key !== 'page_size') {
          obj1[key] = this.parameter[key].address
        } else if (key !== 'page' && key !== 'page_size') {
          obj1[key] = null
        } else {
          obj1[key] = this.parameter[key]
        }
      })

      value === '导出' || this.getDataList(obj1)
      console.log(obj1, 22333)
      return obj1
    },

    // 重置
    reset(value) {
      this.parameter = {
        page: 1,
        page_size: 10,
        release_group_id: null,
        pitcher_id: null,
        operation_group_id: null,
        operation_id: null,
        book_id: null,
        platform_id: null
      }
      this.parameterNames = {
        release_group_id_name: null, // 投放组
        pitcher_id_name: null, // 投手
        operation_group_id_name: null, // 运营组
        operation_id_name: null, // 运营者
        book_name: null,
        platform_name: null
      }
      this.date = []
      this.current = null
      this.getDataList()
    },

    // 导出报表
    async reportExport() {
      const obj = this.search('导出')
      await exportTotalReport({ ...obj,
        begin_time: this.date && this.date.length ? this.date[0] : null,
        end_time: this.date && this.date.length ? this.date[1] : null
      })
      this.$message({
        message: '已在后台中导出',
        type: 'success'
      })
      this.reset('no')
    },

    async blur1() {
      if (this.activeItem.cost !== this.activeText) {
        try {
          await modifyConsumption({ id: this.activeItem.id, cost: this.activeText })
          this.$message({
            message: '修改花费成功',
            type: 'success'
          })
          this.getDataList()
        } catch (err) {
          this.activeItem = null
          this.activeText = null
        }
      }
      this.activeItem = null
      this.activeText = null
    },
    sortChange(cell) {
      console.log('cell:', cell)
      this.order_by['order'] = !cell.order
        ? cell.order : cell.order === 'ascending'
          ? 'asc' : 'desc'
      this.order_by['field'] = !cell.order
        ? cell.order : cell.prop
      this.search('排序')
    }
  }
}
</script>
<style src="@/styles/public1.css"></style>

<style scoped lang="less">
.content{
   .item{
     display: flex;
     align-items: center;
    .item_title{
       display: inline-block;
       width: 100px;
    }
    .item_input{
       width: 200px
    }
   }
}

.selectionArea{
  display: flex;
  flex-wrap: wrap;
  .item{
    display: flex;
    align-items: center;
    margin-right: 20px;
    margin-bottom: 10px;
    .item_title{
       margin-right: 10px;
       display: inline-block;
    }
    .item_input{
      width:200px
    }
  }
}

 .powder {
   background: rgb(248, 216, 216);
 }
 .green {
   background: rgb(52, 229, 54);
 }
 .yellow {
   background: rgb(255, 247, 173);
 }
 .blue {
   background: rgb(158, 211, 252);
 }
 .red {
   background: #ffa500;
 }
 .magRig {
   margin-right: 10px;
 }
 .magLfte {
   margin-left: 10px;
 }
 .chong{
          display: inline-block;
          width: 13px;
          height: 86%;
          margin-left: 6px;
    }
    .mybox{
      margin-left: 20px;
      display: flex;
      align-items: center;
    }
</style>

<style>
.publicItems .el-dialog{
  margin-top: 6vh !important;
}
.content1{
  padding: 13px;
  color: #000;
  display: flex;
  align-items: center;
  font-size: 1rem;
  font-weight: bold;
}
.content1>div:nth-child(1){
  margin-right: 7rem;
}
.content1>div{
  display: flex;
  flex-direction: row;
  align-items: center;
  margin-right: 3rem;
}
.content1>div>div:nth-child(2){
  color: rgb(138, 37, 37);
}
</style>
